import React from "react";
import Link from "next/link";
import { useTranslations } from "../../locales/useTranslations";
import { BiSolidEnvelope } from "react-icons/bi";

const SoftwareDevelopmentMainBanner = () => {
  const { t } = useTranslations();

  return (
    <>
      <div className="mainbanner">
        <div className="software-development-banner">
          <div className="container">
            <div className="software-development-banner-content">
              <h1
                data-aos="fade-up"
                data-aos-delay="100"
                data-aos-duration="1200"
                dangerouslySetInnerHTML={{ __html: t('softwareDevelopment_header_title') }}
              />

              <p data-aos="fade-up" data-aos-delay="200" data-aos-duration="1200">
                {t('softwareDevelopment_header_description')}
              </p>

              <div
                data-aos="fade-up"
                data-aos-delay="300"
                data-aos-duration="1200"
              >
                <Link href="/kontakt" className="default-btn">
                  <BiSolidEnvelope />{t('softwareDevelopment_header_ctaButton')}<span></span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div >
    </>
  );
};

export default SoftwareDevelopmentMainBanner;
